import { render, staticRenderFns } from "./NewOrders.vue?vue&type=template&id=6465af13&scoped=true"
import script from "./NewOrders.vue?vue&type=script&lang=js"
export * from "./NewOrders.vue?vue&type=script&lang=js"
import style0 from "./NewOrders.vue?vue&type=style&index=0&id=6465af13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6465af13",
  null
  
)

export default component.exports